import { URLS } from '../../../consts/endpoints';
import { postData } from '../../../utils/http';
import RESPONSE_CODES from '../../../consts/responseCodes';
import showSnackbar from '../../../utils/showSnackbar';

const cancelMigration = async ({ clientId, externalReference }) => {
  let isSuccess = false;
  try {
    const response = await postData({
      url: `${URLS.QUOTE_CLIENTS_V2}/${clientId}/subscriptions/${externalReference}/cancel_scheduled_migration`
    });

    if (response?.status === RESPONSE_CODES.NO_CONTENT) {
      showSnackbar({
        intlTextKey: 'MESSAGE.CANCEL_MIGRATION_SUCCESS',
        messageType: 'success'
      });
      isSuccess = true;
    }
  } finally {
    return isSuccess;
  }
};

export default cancelMigration;
